import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

interface CTAButtonElementProps {
  variant: 'dark' | 'brand'
}

export const CTAButtonElement = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<CTAButtonElementProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 16px;
  background-color: ${({ variant }) => (variant === 'brand' ? COLORS.brand : COLORS.bgInverse)};
  color: ${COLORS.textInverse};
  font-size: 17px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.17px;
  cursor: pointer;

  /* 로딩 중 — 컬러 배경 유지(회색 비활성 아님), 클릭 차단됨 */
  &[aria-busy='true'] {
    cursor: default;
  }

  &:disabled {
    background-color: ${COLORS.bgDisabled};
    color: ${COLORS.textPlaceholder};
    cursor: not-allowed;
  }
`
